import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const CardStyle = styled(Link)`
  width: 40%;
  &:hover {
    text-decoration: none;
    color: initial;
  }
  .card {
    transition: box-shadow 0.3s;

    &:hover {
      box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
    }
    .card-header {
      display: flex;
      justify-content: space-between;
      span {
        align-self: flex-end;
      }
    }
    .card-footer {
      font-size: 0.8rem;
    }
  }
`;
